import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
    canAccessPath,
    getAccessDeniedText,
    getDefaultAdminPath,
    isLocalAdmin,
    isSuperAdmin,
} from '../../utils/adminAccess';

const safeJsonParse = (value) => {
    try {
        return JSON.parse(value);
    } catch (error) {
        return null;
    }
};

const getStoredUser = () => {
    if (typeof window === 'undefined') return null;

    return safeJsonParse(window.localStorage.getItem('user'));
};

const NoAccess = ({ user }) => {
    const defaultPath = getDefaultAdminPath(user);

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'grid',
                placeItems: 'center',
                padding: 24,
                background: 'var(--site-bg, #f7f8fb)',
                color: 'var(--site-text, #0f172a)',
            }}
        >
            <div
                style={{
                    width: 'min(560px, 100%)',
                    padding: 28,
                    borderRadius: 'var(--site-radius-xl, 22px)',
                    border: '1px solid var(--site-border, rgba(2, 6, 23, .08))',
                    background: 'var(--site-panel, #ffffff)',
                    boxShadow: 'var(--site-shadow-md, 0 14px 34px rgba(2, 6, 23, .1))',
                    textAlign: 'center',
                }}
            >
                <h2 style={{ margin: '0 0 10px' }}>Нет доступа</h2>

                <p
                    style={{
                        margin: '0 0 18px',
                        color: 'var(--site-text-soft, #334155)',
                        lineHeight: 1.5,
                    }}
                >
                    {getAccessDeniedText(user)}
                </p>

                {defaultPath ? (
                    <a
                        href={defaultPath}
                        style={{
                            minHeight: 42,
                            padding: '0 18px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: 'var(--site-radius-pill, 999px)',
                            background: 'var(--site-primary, #4f46e5)',
                            color: 'var(--site-inverse-text, #ffffff)',
                            fontWeight: 800,
                            textDecoration: 'none',
                        }}
                    >
                        Перейти в доступный раздел
                    </a>
                ) : null}
            </div>
        </div>
    );
};

function PrivateRoute({ children }) {
    const location = useLocation();
    const token = window.localStorage.getItem('token');
    const auth = useSelector((state) => state.auth);
    const storedUser = getStoredUser();
    const user = auth?.user?._id ? auth.user : storedUser;

    if (!token) {
        return <Navigate to="/signin" replace />;
    }

    if (!user) {
        return children;
    }

    if (isSuperAdmin(user)) {
        return children;
    }

    if (!isLocalAdmin(user)) {
        return <NoAccess user={user} />;
    }

    const currentPath = location.pathname;

    if (currentPath === '/') {
        const defaultPath = getDefaultAdminPath(user);

        if (defaultPath) {
            return <Navigate to={defaultPath} replace />;
        }
    }

    if (!canAccessPath(user, currentPath)) {
        return <NoAccess user={user} />;
    }

    return children;
}

export default PrivateRoute;